import { GetStaticProps } from 'next'

import query from './queries'

import initApollo, { API } from 'src/api'

export type Props = API.Teams

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.Teams>({
    query,
  })

  return {
    props: data,
  }
}
